import { Extension } from "@tiptap/core"

export const CanvasKeyboardShortcuts = Extension.create({
  name: "canvasKeyboardShortcuts",

  addKeyboardShortcuts() {
    return {
      "Mod-k": () => {
        window.dispatchEvent(new CustomEvent("canvas:open-ai-edit-bubble"))
        return true
      },
      // Link shortcut is handled by the toolbar's link button
      "Mod-Shift-k": () => {
        // Dispatch custom event to open link popover in toolbar
        window.dispatchEvent(new CustomEvent("canvas:open-link-popover"))
        return true
      },
    }
  },
})
